import AccountPreview from './AccountPreview.js';
import AccountingYearCancel from './AccountingYearCancel.js';
import AccountingYear from './AccountingYear.js';
import Accounting from './Accounting.js';
import ArrowBottom from './ArrowBottom.js';
import ArrowDown from './ArrowDown.js';
import ArrowEnd from './ArrowEnd.js';
import ArrowLeft from './ArrowLeft.js';
import ArrowRight from './ArrowRight.js';
import ArrowStart from './ArrowStart.js';
import ArrowTop from './ArrowTop.js';
import ArrowUp from './ArrowUp.js';
import AttachAuto from './AttachAuto.js';
import AttachCancel from './AttachCancel.js';
import Attach from './Attach.js';
import AutotextInsert from './AutotextInsert.js';
import Autotext from './Autotext.js';
import BasicTabs from './BasicTabs.js';
import Basic from './Basic.js';
import BellSolid from './BellSolid.js';
import Book from './Book.js';
import Booking from './Booking.js';
import Budget from './Budget.js';
import Calendar from './Calendar.js';
import CashAccount from './CashAccount.js';
import CashReports from './CashReports.js';
import ChatSolid from './ChatSolid.js';
import Chat from './Chat.js';
import ChevronDownDouble from './ChevronDownDouble.js';
import ChevronDownSolid from './ChevronDownSolid.js';
import ChevronDown from './ChevronDown.js';
import ChevronLeftDouble from './ChevronLeftDouble.js';
import ChevronLeftSolid from './ChevronLeftSolid.js';
import ChevronLeft from './ChevronLeft.js';
import ChevronRightDouble from './ChevronRightDouble.js';
import ChevronRightSolid from './ChevronRightSolid.js';
import ChevronRight from './ChevronRight.js';
import ChevronUpDouble from './ChevronUpDouble.js';
import ChevronUpSolid from './ChevronUpSolid.js';
import ChevronUp from './ChevronUp.js';
import CircleClose from './CircleClose.js';
import CircleMinus from './CircleMinus.js';
import CirclePlus from './CirclePlus.js';
import CircleTick from './CircleTick.js';
import ClampOpen from './ClampOpen.js';
import Clamp from './Clamp.js';
import Close from './Close.js';
import ConnectionEnable from './ConnectionEnable.js';
import ConnectionRevoke from './ConnectionRevoke.js';
import Contacts from './Contacts.js';
import Copy from './Copy.js';
import Courses from './Courses.js';
import Credit from './Credit.js';
import DeletePermanently from './DeletePermanently.js';
import Delete from './Delete.js';
import Depecriate from './Depecriate.js';
import Developer from './Developer.js';
import DistributionTemplate from './DistributionTemplate.js';
import DocumentApprove from './DocumentApprove.js';
import DocumentCreateEntry from './DocumentCreateEntry.js';
import DocumentCut from './DocumentCut.js';
import DocumentError from './DocumentError.js';
import DocumentIsolatePage from './DocumentIsolatePage.js';
import DocumentMerge from './DocumentMerge.js';
import DocumentMove from './DocumentMove.js';
import DocumentPreview from './DocumentPreview.js';
import DocumentReceived from './DocumentReceived.js';
import DocumentRejectedRequest from './DocumentRejectedRequest.js';
import DocumentSplit from './DocumentSplit.js';
import DocumentTime from './DocumentTime.js';
import Document from './Document.js';
import Download from './Download.js';
import Drag from './Drag.js';
import ECopedia from './ECopedia.js';
import ESignature from './ESignature.js';
import Edit from './Edit.js';
import EllipsisHorizontal from './EllipsisHorizontal.js';
import EllipsisVertical from './EllipsisVertical.js';
import EntriesOnAccount from './EntriesOnAccount.js';
import EntriesOpen from './EntriesOpen.js';
import EntriesWarning from './EntriesWarning.js';
import EntryTypeCustomerInvoice from './EntryTypeCustomerInvoice.js';
import EntryTypeCustomerPayment from './EntryTypeCustomerPayment.js';
import EntryTypeJournalEntry from './EntryTypeJournalEntry.js';
import EntryTypeManualCustomerInvoice from './EntryTypeManualCustomerInvoice.js';
import EntryTypeSupplierInvoice from './EntryTypeSupplierInvoice.js';
import EntryTypeSupplierPayment from './EntryTypeSupplierPayment.js';
import EnvelopeApproved from './EnvelopeApproved.js';
import Envelope from './Envelope.js';
import ExpandView from './ExpandView.js';
import Expenses from './Expenses.js';
import ExportToExcel from './ExportToExcel.js';
import ExportToPdf from './ExportToPdf.js';
import Export from './Export.js';
import FilterSolid from './FilterSolid.js';
import Filter from './Filter.js';
import GraphSolid from './GraphSolid.js';
import Hash from './Hash.js';
import Home from './Home.js';
import Images from './Images.js';
import Import from './Import.js';
import InboxEinvoicing from './InboxEinvoicing.js';
import InboxScanning from './InboxScanning.js';
import InboxSmart from './InboxSmart.js';
import Inbox from './Inbox.js';
import Info from './Info.js';
import InventoryMatrix from './InventoryMatrix.js';
import Inventory from './Inventory.js';
import JournalPro from './JournalPro.js';
import LayoutBoth from './LayoutBoth.js';
import LayoutFirst from './LayoutFirst.js';
import LayoutLast from './LayoutLast.js';
import LayoutNone from './LayoutNone.js';
import Layout from './Layout.js';
import LedgerCardCustomerReminder from './LedgerCardCustomerReminder.js';
import LedgerCardManualCustomerInvoice from './LedgerCardManualCustomerInvoice.js';
import LedgerCardObsoleteStock from './LedgerCardObsoleteStock.js';
import LedgerCardOpeningEntry from './LedgerCardOpeningEntry.js';
import LedgerCardReservedEntry from './LedgerCardReservedEntry.js';
import LedgerCardShrinkagePilferage from './LedgerCardShrinkagePilferage.js';
import LedgerCardStockAdjustment from './LedgerCardStockAdjustment.js';
import LedgerCardTransferredOpeningEntry from './LedgerCardTransferredOpeningEntry.js';
import LedgerCard from './LedgerCard.js';
import Lightbulb from './Lightbulb.js';
import Line from './Line.js';
import ListBulleted from './ListBulleted.js';
import ListSearch from './ListSearch.js';
import List from './List.js';
import LockOpen from './LockOpen.js';
import LogOut from './LogOut.js';
import Log from './Log.js';
import Market from './Market.js';
import MatchAmount from './MatchAmount.js';
import MatchEntries from './MatchEntries.js';
import Menu from './Menu.js';
import Mileage from './Mileage.js';
import ModalResize from './ModalResize.js';
import ModalShrink from './ModalShrink.js';
import MoreSolid from './MoreSolid.js';
import More from './More.js';
import Move from './Move.js';
import NavigationList from './NavigationList.js';
import NoteFollowUp from './NoteFollowUp.js';
import NoteRead from './NoteRead.js';
import Note from './Note.js';
import Numbers from './Numbers.js';
import PartnerApi from './PartnerApi.js';
import Period from './Period.js';
import PersonChange from './PersonChange.js';
import PersonMinus from './PersonMinus.js';
import PersonPlus from './PersonPlus.js';
import PersonTick from './PersonTick.js';
import Play from './Play.js';
import PlusMinus from './PlusMinus.js';
import Print from './Print.js';
import ProcessPayment from './ProcessPayment.js';
import ProductLedgerCard from './ProductLedgerCard.js';
import Profile from './Profile.js';
import ProjectCards from './ProjectCards.js';
import Projects from './Projects.js';
import Quicklinks from './Quicklinks.js';
import RatingBankruptcy from './RatingBankruptcy.js';
import RatingPaymentProblems from './RatingPaymentProblems.js';
import Reconciled from './Reconciled.js';
import Refresh from './Refresh.js';
import ReportSolid from './ReportSolid.js';
import Report from './Report.js';
import Restore from './Restore.js';
import RotateLeft from './RotateLeft.js';
import RotateRight from './RotateRight.js';
import Sales from './Sales.js';
import SearchBold from './SearchBold.js';
import Search from './Search.js';
import SecureTick from './SecureTick.js';
import Secure from './Secure.js';
import SettingsSolid from './SettingsSolid.js';
import Settings from './Settings.js';
import Shortcuts from './Shortcuts.js';
import ShowAll from './ShowAll.js';
import ShowLess from './ShowLess.js';
import ShowMore from './ShowMore.js';
import ShowTemplate from './ShowTemplate.js';
import Sliders from './Sliders.js';
import Smartpay from './Smartpay.js';
import SortBy from './SortBy.js';
import Spinner from './Spinner.js';
import StarSolid from './StarSolid.js';
import Star from './Star.js';
import Subscriptions from './Subscriptions.js';
import SystemEntries from './SystemEntries.js';
import Tag from './Tag.js';
import TemplateOverride from './TemplateOverride.js';
import Templates from './Templates.js';
import ThumbBoth from './ThumbBoth.js';
import ThumbDownSolid from './ThumbDownSolid.js';
import ThumbDown from './ThumbDown.js';
import ThumbUpSolid from './ThumbUpSolid.js';
import ThumbUp from './ThumbUp.js';
import Tick from './Tick.js';
import Time from './Time.js';
import TransferCancel from './TransferCancel.js';
import TransferLocked from './TransferLocked.js';
import Transfer from './Transfer.js';
import Undock from './Undock.js';
import Unreconciled from './Unreconciled.js';
import Warning from './Warning.js';
import Webshop from './Webshop.js';
import Website from './Website.js';
import Workflow from './Workflow.js';
import Zoom from './Zoom.js';

const icons = {
  'account-preview': AccountPreview,
  'accounting-year-cancel': AccountingYearCancel,
  'accounting-year': AccountingYear,
  accounting: Accounting,
  'arrow-bottom': ArrowBottom,
  'arrow-down': ArrowDown,
  'arrow-end': ArrowEnd,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'arrow-start': ArrowStart,
  'arrow-top': ArrowTop,
  'arrow-up': ArrowUp,
  'attach-auto': AttachAuto,
  'attach-cancel': AttachCancel,
  attach: Attach,
  'autotext-insert': AutotextInsert,
  autotext: Autotext,
  'basic-tabs': BasicTabs,
  basic: Basic,
  'bell-solid': BellSolid,
  book: Book,
  booking: Booking,
  budget: Budget,
  calendar: Calendar,
  'cash-account': CashAccount,
  'cash-reports': CashReports,
  'chat-solid': ChatSolid,
  chat: Chat,
  'chevron-down-double': ChevronDownDouble,
  'chevron-down-solid': ChevronDownSolid,
  'chevron-down': ChevronDown,
  'chevron-left-double': ChevronLeftDouble,
  'chevron-left-solid': ChevronLeftSolid,
  'chevron-left': ChevronLeft,
  'chevron-right-double': ChevronRightDouble,
  'chevron-right-solid': ChevronRightSolid,
  'chevron-right': ChevronRight,
  'chevron-up-double': ChevronUpDouble,
  'chevron-up-solid': ChevronUpSolid,
  'chevron-up': ChevronUp,
  'circle-close': CircleClose,
  'circle-minus': CircleMinus,
  'circle-plus': CirclePlus,
  'circle-tick': CircleTick,
  'clamp-open': ClampOpen,
  clamp: Clamp,
  close: Close,
  'connection-enable': ConnectionEnable,
  'connection-revoke': ConnectionRevoke,
  contacts: Contacts,
  copy: Copy,
  courses: Courses,
  credit: Credit,
  'delete-permanently': DeletePermanently,
  delete: Delete,
  depecriate: Depecriate,
  developer: Developer,
  'distribution-template': DistributionTemplate,
  'document-approve': DocumentApprove,
  'document-create-entry': DocumentCreateEntry,
  'document-cut': DocumentCut,
  'document-error': DocumentError,
  'document-isolate-page': DocumentIsolatePage,
  'document-merge': DocumentMerge,
  'document-move': DocumentMove,
  'document-preview': DocumentPreview,
  'document-received': DocumentReceived,
  'document-rejected-request': DocumentRejectedRequest,
  'document-split': DocumentSplit,
  'document-time': DocumentTime,
  document: Document,
  download: Download,
  drag: Drag,
  'e-copedia': ECopedia,
  'e-signature': ESignature,
  edit: Edit,
  'ellipsis-horizontal': EllipsisHorizontal,
  'ellipsis-vertical': EllipsisVertical,
  'entries-on-account': EntriesOnAccount,
  'entries-open': EntriesOpen,
  'entries-warning': EntriesWarning,
  'entry-type-customer-invoice': EntryTypeCustomerInvoice,
  'entry-type-customer-payment': EntryTypeCustomerPayment,
  'entry-type-journal-entry': EntryTypeJournalEntry,
  'entry-type-manual-customer-invoice': EntryTypeManualCustomerInvoice,
  'entry-type-supplier-invoice': EntryTypeSupplierInvoice,
  'entry-type-supplier-payment': EntryTypeSupplierPayment,
  'envelope-approved': EnvelopeApproved,
  envelope: Envelope,
  'expand-view': ExpandView,
  expenses: Expenses,
  'export-to-excel': ExportToExcel,
  'export-to-pdf': ExportToPdf,
  export: Export,
  'filter-solid': FilterSolid,
  filter: Filter,
  'graph-solid': GraphSolid,
  hash: Hash,
  home: Home,
  images: Images,
  import: Import,
  'inbox-einvoicing': InboxEinvoicing,
  'inbox-scanning': InboxScanning,
  'inbox-smart': InboxSmart,
  inbox: Inbox,
  info: Info,
  'inventory-matrix': InventoryMatrix,
  inventory: Inventory,
  'journal-pro': JournalPro,
  'layout-both': LayoutBoth,
  'layout-first': LayoutFirst,
  'layout-last': LayoutLast,
  'layout-none': LayoutNone,
  layout: Layout,
  'ledger-card-customer-reminder': LedgerCardCustomerReminder,
  'ledger-card-manual-customer-invoice': LedgerCardManualCustomerInvoice,
  'ledger-card-obsolete-stock': LedgerCardObsoleteStock,
  'ledger-card-opening-entry': LedgerCardOpeningEntry,
  'ledger-card-reserved-entry': LedgerCardReservedEntry,
  'ledger-card-shrinkage-pilferage': LedgerCardShrinkagePilferage,
  'ledger-card-stock-adjustment': LedgerCardStockAdjustment,
  'ledger-card-transferred-opening-entry': LedgerCardTransferredOpeningEntry,
  'ledger-card': LedgerCard,
  lightbulb: Lightbulb,
  line: Line,
  'list-bulleted': ListBulleted,
  'list-search': ListSearch,
  list: List,
  'lock-open': LockOpen,
  'log-out': LogOut,
  log: Log,
  market: Market,
  'match-amount': MatchAmount,
  'match-entries': MatchEntries,
  menu: Menu,
  mileage: Mileage,
  'modal-resize': ModalResize,
  'modal-shrink': ModalShrink,
  'more-solid': MoreSolid,
  more: More,
  move: Move,
  'navigation-list': NavigationList,
  'note-follow-up': NoteFollowUp,
  'note-read': NoteRead,
  note: Note,
  numbers: Numbers,
  'partner-api': PartnerApi,
  period: Period,
  'person-change': PersonChange,
  'person-minus': PersonMinus,
  'person-plus': PersonPlus,
  'person-tick': PersonTick,
  play: Play,
  'plus-minus': PlusMinus,
  print: Print,
  'process-payment': ProcessPayment,
  'product-ledger-card': ProductLedgerCard,
  profile: Profile,
  'project-cards': ProjectCards,
  projects: Projects,
  quicklinks: Quicklinks,
  'rating-bankruptcy': RatingBankruptcy,
  'rating-payment-problems': RatingPaymentProblems,
  reconciled: Reconciled,
  refresh: Refresh,
  'report-solid': ReportSolid,
  report: Report,
  restore: Restore,
  'rotate-left': RotateLeft,
  'rotate-right': RotateRight,
  sales: Sales,
  'search-bold': SearchBold,
  search: Search,
  'secure-tick': SecureTick,
  secure: Secure,
  'settings-solid': SettingsSolid,
  settings: Settings,
  shortcuts: Shortcuts,
  'show-all': ShowAll,
  'show-less': ShowLess,
  'show-more': ShowMore,
  'show-template': ShowTemplate,
  sliders: Sliders,
  smartpay: Smartpay,
  'sort-by': SortBy,
  spinner: Spinner,
  'star-solid': StarSolid,
  star: Star,
  subscriptions: Subscriptions,
  'system-entries': SystemEntries,
  tag: Tag,
  'template-override': TemplateOverride,
  templates: Templates,
  'thumb-both': ThumbBoth,
  'thumb-down-solid': ThumbDownSolid,
  'thumb-down': ThumbDown,
  'thumb-up-solid': ThumbUpSolid,
  'thumb-up': ThumbUp,
  tick: Tick,
  time: Time,
  'transfer-cancel': TransferCancel,
  'transfer-locked': TransferLocked,
  transfer: Transfer,
  undock: Undock,
  unreconciled: Unreconciled,
  warning: Warning,
  webshop: Webshop,
  website: Website,
  workflow: Workflow,
  zoom: Zoom
};

export { icons };
//# sourceMappingURL=index.js.map
